import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus, ShieldCheck, CheckCircle2 } from "lucide-react";

export default function Registro() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({ company_name: "", admin_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const upd = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) return toast.error("Senha precisa de 8+ caracteres");
    setLoading(true);
    try {
      await register(form);
      toast.success("Empresa cadastrada. Bem-vindo(a)!");
      nav("/gestor");
    } catch (e) { toast.error(apiError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 py-16 grid lg:grid-cols-2 gap-10 items-start">
      <div>
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-teal-500/15 border border-teal-500/30 text-teal-300 text-xs font-semibold uppercase tracking-widest mb-4">
          <ShieldCheck className="w-3.5 h-3.5" /> Teste grátis por 7 dias
        </div>
        <h1 className="font-display text-3xl lg:text-4xl font-bold text-white">Cadastre sua empresa</h1>
        <p className="mt-4 text-slate-400">Em minutos você recebe a URL exclusiva do canal, categorias NR-1 pré-configuradas e painel de gestão pronto.</p>
        <ul className="mt-6 space-y-3 text-sm text-slate-200">
          {["Sem cartão de crédito para começar", "Cancele quando quiser", "R$ 299/mês após o trial", "Suporte pt-BR"].map((t, i) => (
            <li key={i} className="flex items-start gap-2"><CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" /> {t}</li>
          ))}
        </ul>
      </div>
      <Card className="p-8 bg-slate-900/60 border-slate-800">
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-slate-300">Razão social ou nome fantasia</Label>
            <Input required value={form.company_name} onChange={(e) => upd("company_name", e.target.value)} data-testid="input-reg-company" className="bg-slate-800 border-slate-700 text-white" />
          </div>
          <div>
            <Label className="text-slate-300">Seu nome</Label>
            <Input required value={form.admin_name} onChange={(e) => upd("admin_name", e.target.value)} data-testid="input-reg-admin-name" className="bg-slate-800 border-slate-700 text-white" />
          </div>
          <div>
            <Label className="text-slate-300">E-mail corporativo</Label>
            <Input type="email" required value={form.email} onChange={(e) => upd("email", e.target.value)} data-testid="input-reg-email" className="bg-slate-800 border-slate-700 text-white" />
          </div>
          <div>
            <Label className="text-slate-300">Senha (mín. 8 caracteres)</Label>
            <Input type="password" required value={form.password} onChange={(e) => upd("password", e.target.value)} data-testid="input-reg-password" className="bg-slate-800 border-slate-700 text-white" />
          </div>
          <Button type="submit" disabled={loading} data-testid="btn-register-submit" className="w-full bg-indigo-600 hover:bg-indigo-700 text-white">
            <UserPlus className="w-4 h-4 mr-2" /> {loading ? "Cadastrando…" : "Criar conta"}
          </Button>
        </form>
        <div className="mt-6 text-center text-sm text-slate-400">
          Já tem conta? <Link to="/login" data-testid="link-to-login" className="text-teal-400 hover:underline">Fazer login</Link>
        </div>
      </Card>
    </div>
  );
}
